import { connect, useSelector } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { withRouter } from "react-router-dom";

import { Button, Card } from "@/component-library";
import CloseOnOutsideClick from "@/components/Common/CloseOnOutsideClick/CloseOnOutsideClick";
import { createClassNameString } from "@/utils/createClassNameString";
import DatePicker from "@/components/UI/DatePicker";
import { ICON_SIZES, ICON_TYPES } from "@/constants/icons";
import { selectIsSchedulingOnBehalfOf } from "@/redux/selectors/calendarSelectors";
import { SettingsIcon } from "@/component-library/Icons/components/SettingsIcon";
import { toggleDatePicker, updateCalendarView, updateSelectedDate } from "@/redux/actions/calendar";

import CalendarFilters from "../Filters/CalendarFilters";
import OnBehalfOfStickyHeader from "../OnBehalfOfStickyHeader/OnBehalfOfStickyHeader";
import ScheduleNavControls from "../ScheduleNavControls/ScheduleNavControls";

import { NAVBAR_OPTIONS } from "./constants";

import "./styles.scss";

const ScheduleNav = ({ className, selectedDay: _selectedDay, view: _view, ...props }) => {
  const isSchedulingOnBehalfOf = useSelector(selectIsSchedulingOnBehalfOf);

  const viewChangeHandler = async (event) => {
    const timeRange = event.target.value;

    // Use Redux Action & Reducer to push dates array to store to be used in other schedule components
    props.updateCalendarView(timeRange);
    // this preforms side effects like fetching the schedule for the view
    props.updateSelectedDate(props.calendar.selectedScheduleDate);
  };

  const buttonRender = () => {
    return NAVBAR_OPTIONS.map((option) => {
      const buttonClass =
        option.value === props.calendar.viewType
          ? "apti-ScheduleNav--button apti-ScheduleNav--button-selected"
          : "apti-ScheduleNav--button";

      return (
        <Button
          className={buttonClass}
          key={option.value}
          onClick={viewChangeHandler}
          value={option.value}
        >
          {option.label} View
        </Button>
      );
    });
  };

  const onDatePickerSelect = (newDate, changeType) => {
    if (changeType !== "monthChange") {
      const clonedSelectedDay = moment(newDate, "YYYY-MM-DD").local();

      props.updateSelectedDate(clonedSelectedDay);
      props.toggleDatePicker();
    }
  };

  return (
    <nav className="apti-ScheduleNav">
      {isSchedulingOnBehalfOf && <OnBehalfOfStickyHeader />}

      <Card className={createClassNameString(["apti-CL apti-ScheduleNav--card px-3", className])}>
        <div className="d-flex">
          <ScheduleNavControls />

          {!isSchedulingOnBehalfOf && <CalendarFilters />}

          <SettingsIcon
            className="apti-ScheduleNav--settings-icon"
            iconSize={ICON_SIZES.MEDIUM}
            iconType={ICON_TYPES.OUTLINE}
            onClick={() => props.history.push("/app/profile#scroll-to-preferences")}
          />
        </div>

        <div className="apti-ScheduleNav--button-group">{buttonRender()}</div>

        {props.calendar.showDatePicker && (
          <CloseOnOutsideClick
            className="d-flex align-items-center"
            setShowComponent={props.toggleDatePicker}
          >
            <div className="apti-ScheduleNavControls__DatePicker-wpr">
              <DatePicker
                externalCtx={props.calendar.selectedScheduleDate}
                onDaySelect={onDatePickerSelect}
              />
            </div>
          </CloseOnOutsideClick>
        )}
      </Card>
    </nav>
  );
};

ScheduleNav.propTypes = {
  className: PropTypes.string,
  selectedDay: PropTypes.instanceOf(moment),
  view: PropTypes.string.isRequired,
};

ScheduleNav.defaultProps = {
  className: undefined,
  selectedDay: moment().local(),
  view: "DAY",
};

const mapStateToProps = (state) => {
  return {
    calendar: state.calendar,
  };
};

const mapDispatchToProps = {
  toggleDatePicker,
  updateCalendarView,
  updateSelectedDate,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleNav));
